import { FC } from 'react';
import { isSrcSetSupported } from '../../utils/featureDetection';
import { getSrcsetString } from 'dibs-image-utils/exports/srcSet';

export type Props = {
    id?: string;
    isClient?: boolean;
    type?: string;
    widths?: number[];
    quality?: number;
    dataTn?: string;
    alt?: string;
    sizes?: string;
    className?: string;
    photo: {
        masterOrZoomPath: string | null;
        largePath: string | null;
    };
};

type InnerProps = {
    src?: string;
    srcSet?: string;
    sizes?: string;
};

export const ResponsiveImage: FC<Props> = props => {
    const { photo, isClient, dataTn, alt, sizes, widths, className, id } = props;
    const { masterOrZoomPath, largePath } = photo;
    const innerProps: InnerProps = {
        src: undefined,
        sizes: undefined,
        srcSet: undefined,
    };

    if (largePath) {
        innerProps.src = largePath;
    }

    if (masterOrZoomPath && sizes) {
        innerProps.sizes = sizes;
        innerProps.srcSet = getSrcsetString(masterOrZoomPath, widths);
    }

    /**
     * Safari has bug when loading dynamically injected img with srcset, need to remove src
     * so it doesn't load 2 images (1 from src and 1 from srcset)
     */
    if (isClient && isSrcSetSupported()) {
        innerProps.src = undefined;
    }

    return <img id={id} alt={alt || ''} data-tn={dataTn} className={className} {...innerProps} />;
};
